<script setup lang="ts">
// Корень приложения: до входа — вход (или приглашение по ссылке), после — маршруты клиента.
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import ShellWarning from "./components/ShellWarning.vue";
import JoinScreen from "./screens/JoinScreen.vue";
import LoginScreen from "./screens/LoginScreen.vue";
import NodeScreen from "./screens/NodeScreen.vue";
import { applyTheme, savedTheme } from "./branding.ts";
import { useSession } from "./stores/session.ts";

const session = useSession();
const route = useRoute();
const router = useRouter();
const joining = computed(() => route.name === "join");
const ready = ref(false);

onMounted(async () => {
  applyTheme(savedTheme());
  // На десктопе сначала спрашиваем оболочку: от неё зависит и адрес узла, и предупреждение о том,
  // что в системе нет хранилища ключей.
  await session.loadShell();
  if (session.baseUrl !== "") {
    // Оформление узла (акцент и шрифт) спрашиваем всегда, а не только на экране входа: после
    // восстановления сессии его иначе никто не применит, и вошедший увидит оформление по умолчанию.
    await session.loadNode().catch(() => undefined);
  }
  // Сессия могла остаться с прошлого раза: пока проверяем, экран входа не показываем — иначе он
  // мигает при каждой перезагрузке у уже вошедшего человека.
  await session.restore();
  ready.value = true;

  // Меню окна и трея просят открыть раздел, а маршрут знает клиент: оболочка про экраны не знает
  // ничего и знать не должна. «Настройки…» из трея — самый частый путь к переключателю уведомлений.
  session.shell?.onOpen(() => {
    void router.push("/settings");
  });
});
</script>

<template>
  <ShellWarning />
  <div v-if="!ready" class="y-center" />
  <!-- На десктопе адрес узла называет человек: клиент лежит локально и не знает, к какой компании он. -->
  <NodeScreen v-else-if="session.shell !== undefined && session.baseUrl === ''" />
  <JoinScreen v-else-if="session.state === undefined && joining" />
  <LoginScreen v-else-if="session.state === undefined" />
  <RouterView v-else />
</template>
